<template>
  <div id="app" :class="$i18n.locale === 'ZH_TW' ? 'm-app_ZH' : ''">
    <router-view />
  </div>
</template>

<script>
import safpBridgeObj from "./plugins/govmo-js-sdk";
export default {
  name: "App",
  mounted() {
    window.onresize = () => {
      this.$store.commit("changeWidth", document.body.clientWidth);
      this.$store.commit("changeHeight", document.body.clientHeight);
    };
    document.title = this.$t("message.doc_title");
  },
  async created() {
    try {
      // 一戶通APP免登錄
      const isApp = safpBridgeObj.isSupport();
      if (isApp) {
        const token = await new Promise((resolve, reject) => {
          safpBridgeObj.getToken({
            success(res) {
              resolve(res.authToken);
            },
            fail(res) {
              reject(res);
            },
          });
        });
        this.$store.commit("changeIsApp", isApp);
        if (token) sessionStorage.setItem("accountToken", token);
        // 根據APP語言設定
        const appLang = safpBridgeObj.getCurrentLanaguage() || null;
        // if (!localStorage.getItem("lan")) {
        if (appLang) {
          if (appLang == "pt") {
            this.$i18n.locale = "PT";
          } else if (appLang == "en") {
            this.$i18n.locale = "PT";
          } else {
            this.$i18n.locale = "ZH_TW";
          }
        }
        // }
      }
    } catch (error) {
      alert("error: " + JSON.stringify(error));
    }

    // 根據url參數設定語言
    if (this.$route.query.lang) {
      if (
        this.$route.query.lang.toUpperCase() == "ZH_TW" ||
        this.$route.query.lang.toUpperCase() == "ZH_CN" ||
        this.$route.query.lang.toUpperCase() == "PT" ||
        this.$route.query.lang.toUpperCase() == "EN"
      )
        localStorage.setItem("lan", this.$route.query.lang.toUpperCase());
      this.$i18n.locale = this.$route.query.lang.toUpperCase();
    }

    this.$store.commit("changeWidth", document.body.clientWidth);
    this.$store.commit("changeHeight", document.body.clientHeight);
    // 解決select在iOS無法彈出輸入法的問題
    // Array.from(document.getElementsByClassName("el-select")).forEach((item) => {
    //   item.children[0].children[0].removeAttribute("readOnly");
    //   item.children[0].children[0].onblur = function () {
    //     let _this = this;
    //     setTimeout(() => {
    //       _this.removeAttribute("readOnly");
    //     }, 200);
    //   };
    // });
    document.title = this.$t("message.doc_title");
  },
};
</script>

<style>
/* .m-app_ZH,
.m-app_ZH button,
.m-app_ZH input,
.m-app_ZH select,
.m-app_ZH textarea {
  font-family: "EUDC", "DSICCC", "MING_MSCS" !important;
} */
html,
body {
  /* width: 100%; */
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "Noto Serif", "Microsoft JhengHei", "Microsoft YaHei", "新細明體",
    "Helvetica Neue", Helvetica, Arial, sans-serif;
}
#app {
}
a {
  color: #333;
  text-decoration: none;
}
.row {
  display: flex;
  flex-direction: row;
}
.row_align_center {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.row_justify_around {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
}
.row_justify_between {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.el-message {
  min-width: 300px;
  max-width: 380px;
  word-break: break-word;
  width: 90%;
}
.childPageTemp_banner {
  width: 100%;
  /* background: linear-gradient(
    270deg,
    rgba(43, 127, 232, 1) 0%,
    rgba(79, 215, 203, 1) 100%
  ); */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.childPageTemp_banner_content {
  width: 100%;
  /* max-width: 1529px; */
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.childPageTemp_banner img {
  width: 100%;
  height: 100%;
}
.childPageTemp_title {
  position: absolute;
  left: 0;
  top: 0;
  width: calc(100% - 24px);
  height: 100%;
  /* max-width: 1440px; */
  padding: 0 12px;
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* justify-content: flex-end; */
}
.childPageTemp_title div {
  width: 100%;
  font-size: 56px;
  white-space: pre-wrap;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 78px;
  text-shadow: 0px 2px 4px rgba(2, 65, 71, 0.81);
  margin-left: 2%;
  max-width: 1440px;
  margin: auto;
  /* text-align: right; */
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.el-message-box {
  max-width: 95%;
}
.el-select-dropdown {
  max-width: 100%;
}
.tips_red {
  color: #f40101;
  font-size: 14px;
  margin-bottom: 12px;
}
.tips_red_PT {
  margin-top: 12px;
}
.el-col-sm-12 {
  display: inline-table;
}
#preview_message {
  font-size: 22px;
  color: #c0c4cc;
  margin-top: 24px;
  width: 100%;
}
.documents_ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
.documents_ul li {
  border-bottom: 1px solid #d8d8d8;
  padding: 24px 0;
  font-size: 20px;
  font-weight: 400;
  color: #3e4143;
  line-height: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.documents_ul li label {
  border-left: 4px solid #38959d;
  padding-left: 32px;
  display: block;
  white-space: pre-wrap;
  /* word-break: keep-all; */
}
.modal-body ul {
  list-style-type: decimal;
}
.modal-body ul li {
  margin-bottom: 10px;
}
ul.terms-ul-inline {
  list-style-type: none;
  padding-left: 20px;
}
ul.terms-ul-inline li {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
ul.terms-ul-inline li > span {
  margin-right: 5px;
}

.success {
  height: 700px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  margin: auto;
  text-align: center;
}
.success img {
  width: 96px;
  height: auto;
  margin-bottom: 36px;
}
.success > span {
  font-size: 24px;
  color: #515151;
  line-height: 33px;
}
input:disabled {
  opacity: 1;
  -webkit-text-fill-color: #777;
}
.el-message__content {
  font-size: 18px;
  white-space: pre-wrap;
  line-height: 22px;
}
.el-tooltip__popper {
  white-space: pre-wrap;
}
.m-divider-box {
  border: 2px solid #dcdfe6;
  height: 80px;
  background: #fff;
  margin-top: 20px;
  position: relative;
  text-align: center;
}
.m-divider__text {
  left: 20px;
  transform: translateY(-50%);
  padding: 0 20px;
  background: #fff;
  position: absolute;
  background-color: #fff;
  color: #303133;
  font-size: 16px;
}
.m-divider__content {
  line-height: 80px;
}
@media screen and (max-width: 767px) {
  .childPageTemp_title div {
    font-size: 26px;
    line-height: 35px;
  }
  .childPageTemp_banner div {
    font-size: 22px;
    line-height: 35px;
  }
  .childPageTemp_title_PT div,
  .childPageTemp_title_EN div {
    font-size: 16px !important;
    line-height: 30px !important;
  }
  .documents_ul li {
    font-size: 16px;
  }
  .documents_ul li label {
    padding-left: 12px;
    padding-right: 12px;
  }
}
@media screen and (min-width: 768px) {
  .childPageTemp_title_PT div,
  .childPageTemp_title_EN div {
    font-size: 35px !important;
    line-height: 50px !important;
  }
}
</style>
<style lang="scss" scoped>
/deep/.ps_msgBox {
  max-width: 865px;
  margin: 0 auto;
}
/deep/.ps_msg_failed {
  background: #fcf1f2;
  border: 1px solid #f2adb4;
  padding: 30px 15px;
  margin: auto;
  text-align: center;
  border-radius: 5px;
  .failed_text {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #d81e08;
    i {
      margin-right: 12px;
    }
  }
  .failed_reason {
    font-size: 22px;
    margin: 20px 0;
  }
}
/deep/.m-tempsave-tips {
  color: #f40101;
  font-size: 16px;
}
/deep/.view_sample_danger {
  background: #fff !important;
  border-color: #f55159 !important;
  color: #f55159 !important;
  min-width: 98px;
}
/deep/.view_sample_danger:hover {
  background: #f55159 !important;
  border-color: #f55159 !important;
  color: #fff !important;
}
</style>
